<template>
    <div class="row">
        <div class="col-md-12">
            <div class="d-flex justify-content-center align-items-center">
                <h1 class="d-flex justify-content-center">Travel Expense Report </h1>
                <span v-if="!loading && expenseReportID" class="fa fa-print ml-2 fa-lg" @click="$router.push({ name: 'travel-expense-report-print', params: { erid: expenseReportID } })" title="Print View"></span>
            </div>
            <a class="d-flex justify-content-center" href="https://drive.google.com/file/d/1BVrfNtkEoq_jL1Fc-u1BPPv7hhv8PPSD/view?usp=sharing" target="_blank">Travel Reimbursement Policy</a>
            <ul class="nav nav-pills d-flex justify-content-center">
                <li class="nav-item"> <div class="totaltext"></div><router-link style="font-weight:900;" class="nav-link" :to="{ name: 'travel-expense-report', params: {erid: expenseReportID } }">Trip Profile </router-link>
                <li class="nav-item">
                    <div class="totaltext">
                        <span v-show="summaryCosts.airfareReimbursementAmount > 0">$</span>
                        <span v-if="summaryCosts.airfareReimbursementAmount == null || summaryCosts.airfareReimbursementAmount == 0">-</span>
                        <vue-odometer v-show="summaryCosts.airfareReimbursementAmount > 0" format='' :value="summaryCosts.airfareReimbursementAmount"></vue-odometer>
                    </div>
                    <router-link style="font-weight:900;" v-bind:class="{ disabled: linksDisabled }" class="nav-link" :to="{ name: 'air', params: {erid: expenseReportID } }">Air </router-link>
                </li>
                <li class="nav-item">
                    <div class="totaltext">
                        <span v-show="summaryCosts.lodgingReimbursementAmount > 0">$</span>
                        <span v-if="summaryCosts.lodgingReimbursementAmount == null || summaryCosts.lodgingReimbursementAmount == 0">-</span>
                        <vue-odometer v-show="summaryCosts.lodgingReimbursementAmount > 0" format='' :value="summaryCosts.lodgingReimbursementAmount"></vue-odometer>
                    </div><router-link style="font-weight:900;" v-bind:class="{ disabled: linksDisabled }" class="nav-link" :to="{ name: 'lodging', params: {erid: expenseReportID } }">Lodging </router-link>
                </li>
                <li class="nav-item">
                    <div class="totaltext">
                        <span v-show="summaryCosts.mealReimbursementAmount > 0">$</span>
                        <span v-if="summaryCosts.mealReimbursementAmount == null || summaryCosts.mealReimbursementAmount == 0">-</span>
                        <vue-odometer v-show="summaryCosts.mealReimbursementAmount > 0" format='' :value="summaryCosts.mealReimbursementAmount"></vue-odometer>                     
                    </div><router-link style="font-weight:900;" v-bind:class="{ disabled: linksDisabled }" class="nav-link" :to="{ name: 'meals', params: {erid: expenseReportID } }">Meals </router-link>
                </li>
                <li class="nav-item">
                    <div class="totaltext">
                        <span v-show="summaryCosts.carRentalReimbursementAmount > 0">$</span>
                        <span v-if="summaryCosts.carRentalReimbursementAmount == null || summaryCosts.carRentalReimbursementAmount == 0">-</span>
                        <vue-odometer v-show="summaryCosts.carRentalReimbursementAmount > 0" format='' :value="summaryCosts.carRentalReimbursementAmount"></vue-odometer>     
                    </div><router-link style="font-weight:900;" v-bind:class="{ disabled: linksDisabled }" class="nav-link" :to="{ name: 'rental-car', params: {erid: expenseReportID } }">Rental Car </router-link>
                </li>
                <li class="nav-item">
                    <div class="totaltext">
                        <span v-show="summaryCosts.otherCombinedCostReimbursementAmount > 0">$</span>
                        <span v-if="summaryCosts.otherCombinedCostReimbursementAmount == null || summaryCosts.otherCombinedCostReimbursementAmount == 0">-</span>
                        <vue-odometer v-show="summaryCosts.otherCombinedCostReimbursementAmount > 0" format='' :value="summaryCosts.otherCombinedCostReimbursementAmount"></vue-odometer>                     
                    </div><router-link style="font-weight:900;" v-bind:class="{ disabled: linksDisabled }" class="nav-link" :to="{ name: 'other', params: {erid: expenseReportID } }">Other </router-link>
                </li>
                <li class="nav-item">
                    <div class="totaltext">
                        <span v-show="summaryCosts.totalReimbursementAmount > 0">$</span>
                        <span v-if="summaryCosts.totalReimbursementAmount == null || summaryCosts.totalReimbursementAmount == 0">-</span>
                        <vue-odometer v-show="summaryCosts.totalReimbursementAmount > 0" format='' :value="summaryCosts.totalReimbursementAmount"></vue-odometer>                        
                    </div><router-link style="font-weight:900;" v-bind:class="{ disabled: linksDisabled }" class="nav-link" :to="{ name: 'review-submit', params: {erid: expenseReportID } }">Review / Submit </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import VueOdometer from 'v-odometer/src'
    export default {
        name: 'TravelExpenseReportTabs',
        components: {
            'vue-odometer': VueOdometer
        },
        props: {
            linksDisabled: {
                type: Boolean,
                required: true
            },
            expenseReportID: {
                type: String,
                required: false
            }
        },
        created() {
            if (this.$route.params.erid) {
                this.expenseReportID = this.$route.params.erid;
                this.setInitialSummary();
                this.getSummaryCosts();
            }
        },
        data: function () {
            return {
                summaryCosts: {
                    airfareReimbursementAmount: null,
                    lodgingReimbursementAmount: null,
                    mealReimbursementAmount: null,
                    carRentalReimbursementAmount: null,
                    otherCombinedCostReimbursementAmount: null,
                    totalReimbursementAmount: null
                },
                loading: true,
            }
        },
        methods: {
            setInitialSummary() {
                this.summaryCosts.airfareReimbursementAmount = this.$traveExpenseReportTotals.airfareReimbursementAmount;
                this.summaryCosts.lodgingReimbursementAmount = this.$traveExpenseReportTotals.lodgingReimbursementAmount;
                this.summaryCosts.mealReimbursementAmount = this.$traveExpenseReportTotals.mealReimbursementAmount;
                this.summaryCosts.carRentalReimbursementAmount = this.$traveExpenseReportTotals.carRentalReimbursementAmount;
                this.summaryCosts.miscCostReimbursementAmount = this.$traveExpenseReportTotals.miscCostReimbursementAmount;
                this.summaryCosts.otherCombinedCostReimbursementAmount = Number(this.$traveExpenseReportTotals.miscCostReimbursementAmount) + Number(this.$traveExpenseReportTotals.groundTransportationReimbursementAmount) + Number(this.$traveExpenseReportTotals.personalVehicleMileageReimbursementAmount);
                this.summaryCosts.totalReimbursementAmount = this.$traveExpenseReportTotals.totalReimbursementAmount;
            },
            getSummaryCosts() {
                this.$http
                    .get(`expensereports/${this.expenseReportID}/Review`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        //set VM ammount so it will track changes against original saved value.
                        this.summaryCosts.airfareReimbursementAmount = response.data.airfareReimbursementAmount;
                        //set global saved value so when componenet reloaded it has something to compare to when getting latest values. If changed animation will play.
                        this.$traveExpenseReportTotals.airfareReimbursementAmount = response.data.airfareReimbursementAmount;

                        this.summaryCosts.lodgingReimbursementAmount = response.data.lodgingReimbursementAmount;
                        this.$traveExpenseReportTotals.lodgingReimbursementAmount = response.data.lodgingReimbursementAmount;

                        this.summaryCosts.mealReimbursementAmount = response.data.mealReimbursementAmount;
                        this.$traveExpenseReportTotals.mealReimbursementAmount = response.data.mealReimbursementAmount;

                        this.summaryCosts.carRentalReimbursementAmount = response.data.carRentalReimbursementAmount;
                        this.$traveExpenseReportTotals.carRentalReimbursementAmount = response.data.carRentalReimbursementAmount;

                        this.summaryCosts.otherCombinedCostReimbursementAmount = Number(response.data.miscCostReimbursementAmount) + Number(response.data.groundTransportationReimbursementAmount) + Number(response.data.personalVehicleMileageReimbursementAmount);
                        this.$traveExpenseReportTotals.otherCombinedCostReimbursementAmount = Number(response.data.miscCostReimbursementAmount) + Number(response.data.groundTransportationReimbursementAmount) + Number(response.data.personalVehicleMileageReimbursementAmount);

                        this.summaryCosts.totalReimbursementAmount = response.data.totalReimbursementAmount;
                        this.$traveExpenseReportTotals.totalReimbursementAmount = response.data.totalReimbursementAmount;

                        this.summaryCosts.miscCostReimbursementAmount = response.data.miscCostReimbursementAmount;
                        this.$traveExpenseReportTotals.miscCostReimbursementAmount = response.data.miscCostReimbursementAmount;

                        this.$traveExpenseReportTotals.groundTransportationReimbursementAmount = response.data.groundTransportationReimbursementAmount;
                        this.$traveExpenseReportTotals.personalVehicleMileageReimbursementAmount = response.data.personalVehicleMileageReimbursementAmount;

                        this.loading = false;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            }
        },
        computed: {
            disableLink: function () {
                return this.linksDisabled;
            }
        }
    }
</script>
<style scoped>
    .totaltext {
        min-height: 28.667px;
        text-align: center;
        font-weight: bold;
    }
</style>